import { render, staticRenderFns } from "./SelfcheckErrorModal.vue?vue&type=template&id=2bb3d9bd&scoped=true&"
import script from "./SelfcheckErrorModal.vue?vue&type=script&lang=js&"
export * from "./SelfcheckErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfcheckErrorModal.vue?vue&type=style&index=0&id=2bb3d9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3d9bd",
  null
  
)

export default component.exports